import React from 'react';
import PageContainer from '../components/layout/PageContainer';
import { NotificationTabs } from '../components/notifications/NotificationTabs';
import { useLanguage } from '../contexts/LanguageContext';

const NotificationsPage = () => {
  const { t } = useLanguage();

  return (
    <PageContainer title={t('notifications')}>
      <div className="h-full bg-gray-50">
        <NotificationTabs />
      </div>
    </PageContainer>
  );
};

export default NotificationsPage; 